$('.new-review__form').on('submit', function (e) {
  e.preventDefault();
  var projectname = $('#projectname').val();
  var editor = $('#editor').val();
  var customer = $('#customer').val();
  $.ajax({
    url: settings.ajaxurl,
    type: "POST",
    data: {
      action: 'set_form',
      projectname: projectname,
      editor: editor,
      customer: customer
    },
    success: function success(response) {
      if (response['id']) {
        $('#review-id').val(response['id']);
        url = window.location.href + '?id=' + response['id'];
        window.location = url;
        $(".new-review").hide();
        $(".new-review-tabs").show();
        $(".header .btn").show();
      }
    }
  });
});
tinyMCE.init({
  mode: "specific_textareas",
  editor_selector: "tinymce-enabled",
  selector: 'textarea',
  plugins: 'lists advlist'
});
$(document).on('click', '.new-review-tabs__form .save, .new-review-tabs__form .secondary-tabs .btn, .new-review-tabs__form .main-tabs a, .close-review', function (e) {
  $(window).scrollTop(0);
  var $this = $(this);
  var review_id = $('#review_id').val();
  var file_data_logo = $('#image1').prop('files')[0];
  var file_data_bg_image = $('#pdf_bg_image_image').prop('files')[0]; // let file_data_image1_2 = $('#image1_2').prop('files')[0];

  var file_data_image1_3_1 = $('#image1_3_1').prop('files')[0];
  var file_data_image1_3_2 = $('#image1_3_2').prop('files')[0];
  var file_data_image1_4_1 = $('#image1_4_1').prop('files')[0];
  var file_data_image1_4_2 = $('#image1_4_2').prop('files')[0];
  var file_data_image1_4_3 = $('#image1_4_3').prop('files')[0];
  var textareaContent = tinymce.get("textarea").getContent();
  var pdf_bg_image_radio = $('input[name="pdf_bg_image_radio"]:checked').val();
  var page_number = $("#page_number").is(":checked") ? 1 : 0;
  var location = $("#location").val();
  var date = $("#date").val();
  var textarea1_2 = tinymce.get("textarea1_2").getContent();
  var textarea1_3 = tinymce.get("textarea1_3").getContent(); // roadmap 3.2

  var file_data_pdf_bg_image_roadmap = $('#pdf_bg_image_image_roadmap').prop('files')[0];
  var pdf_bg_image_roadmap_radio = $('input[name="pdf_bg_roadmap_image_radio"]:checked').val();
  var textarea3_2_1 = tinymce.get("textarea3_2_1").getContent();
  var textarea3_2_2 = tinymce.get("textarea3_2_2").getContent();
  var textarea3_2_3 = tinymce.get("textarea3_2_3").getContent(); // for 2 parent tabs

  var tabsLength2 = $(".secondary-tabs[data-tab='2']>ul>li").length; // for 2 child tabs

  textareaFirst2_child = [[], [], [], [], [], []];
  textareaSecond2_child = [[], [], [], [], [], []];
  textareaThird2_child = [[], [], [], [], [], []]; // fileDataImageFirst2_child = [[], [], [], [], [], []];

  fileDataImageSecond2_child = [[], [], [], [], [], []];
  fileDataImageThird2_child = [[], [], [], [], [], []];
  typeRecom2_child = [[], [], [], [], [], []];

  for (var i = 1; i <= tabsLength2; i++) {
    var tabsLength2_child = $(".tab-wrapper[data-tab='2." + i + "']>ul>li").length;

    for (var j = 1; j <= tabsLength2_child; j++) {
      if ($("#textarea2_" + i + "_" + j + "_1").length) {
        textareaFirst2_child[i - 1][j - 1] = tinymce.get("textarea2_" + i + "_" + j + "_1").getContent();
      } else {
        textareaFirst2_child[i - 1][j - 1] = '';
      }

      if ($("#textarea2_" + i + "_" + j + "_2").length) {
        textareaSecond2_child[i - 1][j - 1] = tinymce.get("textarea2_" + i + "_" + j + "_2").getContent();
      } else {
        textareaSecond2_child[i - 1][j - 1] = '';
      }

      if ($("#textarea2_" + i + "_" + j + "_3").length) {
        textareaThird2_child[i - 1][j - 1] = tinymce.get("textarea2_" + i + "_" + j + "_3").getContent();
      } else {
        textareaThird2_child[i - 1][j - 1] = '';
      } // if ($('#image2_' + i + "_" + j + "_1").length) {
      //     fileDataImageFirst2_child[i - 1][j - 1] = $('#image2_' + i + "_" + j + "_1").prop('files')[0];
      // } else {
      //     fileDataImageFirst2_child[i - 1][j - 1] = '';
      // }


      if ($('#image2_' + i + "_" + j + "_2").length) {
        fileDataImageSecond2_child[i - 1][j - 1] = $('#image2_' + i + "_" + j + "_2").prop('files')[0];
      } else {
        fileDataImageSecond2_child[i - 1][j - 1] = '';
      }

      if ($('#image2_' + i + "_" + j + "_3").length) {
        fileDataImageThird2_child[i - 1][j - 1] = $('#image2_' + i + "_" + j + "_3").prop('files')[0];
      } else {
        fileDataImageThird2_child[i - 1][j - 1] = '';
      }

      if ($('input[name="type_recom2_' + i + "_" + j + '"]:checked').length) {
        typeRecom2_child[i - 1][j - 1] = $('input[name="type_recom2_' + i + "_" + j + '"]:checked').val();
      } else {
        typeRecom2_child[i - 1][j - 1] = '';
      }
    }
  }

  if ($this.hasClass("save")) {
    tab = $this.data('tab');
    tabWrapper = $this.parents('.tab-wrapper');
    tabMain = tab.toString().split('.').shift();
  }

  var form_data = new FormData();
  form_data.append('file_logo', file_data_logo);
  form_data.append('file_bg_image', file_data_bg_image); // form_data.append('file_image1_2', file_data_image1_2);

  form_data.append('file_image1_3_1', file_data_image1_3_1);
  form_data.append('file_image1_3_2', file_data_image1_3_2);
  form_data.append('file_image1_4_1', file_data_image1_4_1);
  form_data.append('file_image1_4_2', file_data_image1_4_2);
  form_data.append('file_image1_4_3', file_data_image1_4_3);
  form_data.append('action', 'save_review_data');
  form_data.append('textareaContent', textareaContent);
  form_data.append('review_id', review_id);
  form_data.append('pdf_bg_image_radio', pdf_bg_image_radio);
  form_data.append('page_number', page_number);
  form_data.append('location', location);
  form_data.append('date', date);
  form_data.append('textarea1_2', textarea1_2);
  form_data.append('textarea1_3', textarea1_3); // roadmap 3.2

  form_data.append('file_data_pdf_bg_image_roadmap', file_data_pdf_bg_image_roadmap);
  form_data.append('pdf_bg_image_roadmap_radio', pdf_bg_image_roadmap_radio);
  form_data.append('textarea3_2_1', textarea3_2_1);
  form_data.append('textarea3_2_2', textarea3_2_2);
  form_data.append('textarea3_2_3', textarea3_2_3); // for 2 child tabs

  for (var i = 1; i <= tabsLength2; i++) {
    var _tabsLength2_child = $(".tab-wrapper[data-tab='2." + i + "']>ul>li").length;

    for (var j = 1; j <= _tabsLength2_child; j++) {
      form_data.append('textarea2_' + i + '_' + j + '_1', textareaFirst2_child[i - 1][j - 1]);
      form_data.append('textarea2_' + i + '_' + j + '_2', textareaSecond2_child[i - 1][j - 1]);
      form_data.append('textarea2_' + i + '_' + j + '_3', textareaThird2_child[i - 1][j - 1]); // form_data.append('file_image2_' + i + '_' + j + "_1", fileDataImageFirst2_child[i - 1][j - 1]);

      form_data.append('file_image2_' + i + '_' + j + "_2", fileDataImageSecond2_child[i - 1][j - 1]);
      form_data.append('file_image2_' + i + '_' + j + "_3", fileDataImageThird2_child[i - 1][j - 1]);
      form_data.append('type_recom2_' + i + '_' + j, typeRecom2_child[i - 1][j - 1]);
    }
  } // Roadmap


  $(".roadmap-items .tab-wrapper__item").each(function (i) {
    var title = $(this).find(".topic_title").val();
    var badge = $(this).find(".topic_badge:checked").val();
    form_data.append('topic_title' + (i + 1), title);
    form_data.append('topic_badge' + (i + 1), badge);
  });
  jQuery.ajax({
    url: settings.ajaxurl,
    type: 'post',
    contentType: false,
    processData: false,
    data: form_data,
    beforeSend: function beforeSend() {
      $(".overlay").css('display', 'flex');
    },
    success: function success(response) {
      $(".overlay").hide(); // $(".response").text(response);

      $('.upload-file-input').val('');

      if ($this.hasClass("save")) {
        tabWrapper.removeClass('active');
        $(".tab-wrapper[data-tab='" + tab + "']").addClass('active');
        $(".secondary-tabs a").removeClass('active');
        $(".secondary-tabs a[data-tab='" + tab + "']").addClass('active');
        $(".secondary-tabs").removeClass('active');
        $(".secondary-tabs[data-tab='" + tabMain + "']").addClass('active');
        $(".main-tabs a").removeClass('active');
        $(".main-tabs a[data-tab='" + tabMain + "']").addClass('active');
      }

      if ($this.hasClass("close-review")) {
        var homeUrl = $("header").find(".logo-link").attr('href');
        window.location = homeUrl;
      }
    },
    error: function error(response) {
      console.log('error');
    }
  });
});
$(document).on('mouseup', '.upload-file-input, .expand-extra-items', function (e) {
  if ($(this).hasClass('expand-extra-items')) {
    $(this).find('.helper').css('background-color', '#F1F1F1');
  } else {
    $(this).siblings('.helper').css('background-color', '#F1F1F1');
  }
});
$(document).on('mouseout', '.upload-file-input, .expand-extra-items', function (e) {
  if ($(this).hasClass('expand-extra-items')) {
    $(this).find('.helper').css('background-color', '#F1F1F1');
  } else {
    $(this).siblings('.helper').css('background-color', '#F1F1F1');
  }
});
$(document).on('mousedown', '.upload-file-input, .expand-extra-items', function (e) {
  if ($(this).hasClass('expand-extra-items')) {
    $(this).find('.helper').css('background-color', 'rgb(79, 78, 86)');
  } else {
    $(this).siblings('.helper').css('background-color', 'rgb(79, 78, 86)');
  }
});
$(document).on('mouseover', '.upload-file-input, .expand-extra-items', function (e) {
  if ($(this).hasClass('expand-extra-items')) {
    $(this).find('.helper').css('background-color', 'rgb(224, 224, 224)');
  } else {
    $(this).siblings('.helper').css('background-color', 'rgb(224, 224, 224)');
  }
});
$(document).on('mouseleave', '.upload-file-input, .expand-extra-items', function (e) {
  if ($(this).hasClass('expand-extra-items')) {
    $(this).find('.helper').css('background-color', '#F1F1F1');
  } else {
    $(this).siblings('.helper').css('background-color', '#F1F1F1');
  }
});
$('.upload-file-input').on("change", function () {
  var filename = $(this)[0].files.length ? $(this)[0].files[0].name : "";

  if (filename !== "") {
    $(this).parents(".tab-wrapper__item--file").addClass("file-uploaded");
    $(this).parents(".upload").siblings(".uploaded").find(".name").text(filename);
    $(this).parents(".upload").siblings(".uploaded").find("img").attr("src", window.URL.createObjectURL($(this)[0].files[0]));
  }
});
$(document).on('click', '.main-tabs a', function (e) {
  e.preventDefault();
  var tab = $(this).data('tab');
  $(".main-tabs a").removeClass('active');
  $(this).addClass('active');
  $(".secondary-tabs").removeClass('active');
  $(".secondary-tabs[data-tab='" + tab + "']").addClass('active');
  $(".secondary-tabs a").removeClass('active');
  $(".secondary-tabs[data-tab='" + tab + "']").find("li").first().find("a").addClass('active');
  $(".tab-wrapper").removeClass('active');
  $(".tab-wrapper[data-tab='" + tab + ".1']").addClass('active');
});
$(document).on('click', '.secondary-tabs a', function (e) {
  e.preventDefault();
  var tab = $(this).data('tab');
  $(".secondary-tabs a").removeClass('active');
  $(this).addClass('active');
  $(".tab-wrapper").removeClass('active');
  $(".tab-wrapper[data-tab='" + tab + "']").addClass('active');
});
$(document).on('click', '.new-review-tabs__form .back', function (e) {
  e.preventDefault();
  var tab = $(this).data('tab');
  tabMain = tab.toString().split('.').shift();
  $(".tab-wrapper").removeClass('active');
  $(".tab-wrapper[data-tab='" + tab + "']").addClass('active');
  $(".secondary-tabs a").removeClass('active');
  $(".secondary-tabs a[data-tab='" + tab + "']").addClass('active');
  $(".secondary-tabs").removeClass('active');
  $(".secondary-tabs[data-tab='" + tabMain + "']").addClass('active');
  $(".main-tabs a").removeClass('active');
  $(".main-tabs a[data-tab='" + tabMain + "']").addClass('active');
});
$(document).on('click', '.tab-wrapper__title .dropdown', function (e) {
  var wrapper = $(this).parents("li");
  var items = wrapper.find(".tab-wrapper__items");
  items.slideToggle();
  $(this).toggleClass("opened");
});
$('.check-item').on("change", function () {
  var id = $(this).attr('id');
  id = id.replace('item_', '');
  var tab = id.split('_');
  var $this = $(this);
  var pdfLink = $('.gen-pdf').attr('href');
  url = new URL(pdfLink);
  urlParams = url.searchParams; // for 2 child items start

  if ($(this).hasClass('check-item-subitem')) {
    stepValues = urlParams.get('step' + tab[0] + '_' + tab[1]);
    index = tab[2] - 1;

    if ($(".check-item-subitem[id*='item_" + tab[0] + '_' + tab[1] + "_']:checked").length == 0) {
      $(".check-item[id='item_" + tab[0] + '_' + tab[1] + "']").prop('checked', false);
      stepValuesSubitem = urlParams.get('step' + tab[0]);
      indexSubitem = tab[1] - 1;
      stepValuesArrSubitem = stepValuesSubitem.split('_');
      stepValuesArrSubitem[indexSubitem] = 0;
      stepValuesStringNewSubitem = stepValuesArrSubitem.join("_");
      urlParams.set('step' + tab[0], stepValuesStringNewSubitem);
      $(".check-item--final-small[id='item_4_" + tab[0] + '_' + tab[1] + "']").prop('checked', false);
    }

    if ($(".check-item-subitem[id*='item_" + tab[0] + '_' + tab[1] + "_']:checked").length > 0) {
      $(".check-item[id='item_" + tab[0] + '_' + tab[1] + "']").prop('checked', true);
      stepValuesSubitem = urlParams.get('step' + tab[0]);
      indexSubitem = tab[1] - 1;
      stepValuesArrSubitem = stepValuesSubitem.split('_');
      stepValuesArrSubitem[indexSubitem] = 1;
      stepValuesStringNewSubitem = stepValuesArrSubitem.join("_");
      urlParams.set('step' + tab[0], stepValuesStringNewSubitem);
      $(".check-item--final-small[id='item_4_" + tab[0] + '_' + tab[1] + "']").prop('checked', true);
    } // for 2 child items end
    // for 4 step small items start

  } else if ($(this).hasClass('check-item--final-small')) {
    stepValues = urlParams.get('step' + tab[1]);
    index = tab[2] - 1;

    if ($(this).parents(".tab-wrapper__subitems").find(".check-item:checked").length == 0) {
      $(".check-item--final[id='item_4_" + tab[1] + "']").prop('checked', false);
    }

    if ($(this).parents(".tab-wrapper__subitems").find(".check-item:checked").length > 0) {
      $(".check-item--final[id='item_4_" + tab[1] + "']").prop('checked', true);
    } // for 4 step small items end

  } else {
    stepValues = urlParams.get('step' + tab[0]);
    index = tab[1] - 1;

    if (!$this.is(':checked')) {
      $(".check-item--final-small[id='item_4_" + tab[0] + '_' + tab[1] + "']").prop('checked', false);
    } else {
      $(".check-item--final-small[id='item_4_" + tab[0] + '_' + tab[1] + "']").prop('checked', true);
    }

    if ($(".check-item[id*='item_" + tab[0] + "_']:checked").length == 0) {
      $(".check-item--final[id='item_4_" + tab[0] + "']").prop('checked', false);
    }

    if ($(".check-item[id*='item_" + tab[0] + "_']:checked").length > 0) {
      $(".check-item--final[id='item_4_" + tab[0] + "']").prop('checked', true);
    }

    if ($(this).parents(".tab-wrapper").hasClass("has-subitems")) {
      if (!$(this).is(':checked')) {
        $(this).parents(".tab-wrapper").find(".check-item-subitem").prop('checked', false);
      } else {
        $(this).parents(".tab-wrapper").find(".check-item-subitem").prop('checked', true);
      }
    }
  }

  stepValuesArr = stepValues.split('_');

  if (!$(this).is(':checked')) {
    stepValuesArr[index] = 0;
  } else {
    stepValuesArr[index] = 1;
  }

  stepValuesStringNew = stepValuesArr.join("_"); // console.log(stepValuesStringNew);

  if ($(this).hasClass('check-item-subitem')) {
    urlParams.set('step' + tab[0] + '_' + tab[1], stepValuesStringNew);
  } else if ($(this).hasClass('check-item--final-small')) {
    urlParams.set('step' + tab[1], stepValuesStringNew);

    if (!$this.is(':checked')) {
      $(".check-item[id='item_" + tab[1] + '_' + tab[2] + "']").prop('checked', false);
      $(".check-item-subitem[id*='item_" + tab[1] + '_' + tab[2] + "_']").prop('checked', false);
      subItemsString = '';
      $(".check-item-subitem[id*='item_" + tab[1] + '_' + tab[2] + "_']").each(function () {
        subItemsString += '0_';
      });
      subItemsString = subItemsString.slice(0, -1);
      urlParams.set('step' + tab[1] + '_' + tab[2], subItemsString);
    } else {
      $(".check-item[id='item_" + tab[1] + '_' + tab[2] + "']").prop('checked', true);
      $(".check-item-subitem[id*='item_" + tab[1] + '_' + tab[2] + "_']").prop('checked', true);
      subItemsString = '';
      $(".check-item-subitem[id*='item_" + tab[1] + '_' + tab[2] + "_']").each(function () {
        subItemsString += '1_';
      });
      subItemsString = subItemsString.slice(0, -1);
      urlParams.set('step' + tab[1] + '_' + tab[2], subItemsString);
    }
  } else {
    urlParams.set('step' + tab[0], stepValuesStringNew);

    if ($(this).parents(".tab-wrapper").hasClass("has-subitems")) {
      countSubItems = $(this).parents(".tab-wrapper").find(".tab-wrapper__subitems").find("li").length;
      subItemsString = '';
      $(this).parents(".tab-wrapper").find(".tab-wrapper__subitems").find("li").each(function (index) {
        if (!$this.is(':checked')) {
          subItemsString += "0_";
        } else {
          subItemsString += "1_";
        }
      });
      subItemsString = subItemsString.slice(0, -1);
      urlParams.set('step' + tab[0] + '_' + tab[1], subItemsString);
    }
  } // for 4th step


  if ($(this).hasClass('check-item--final')) {
    countSubItems = $(this).parents(".tab-wrapper__title").next().find("li").length;
    subItemsString = '';
    $(this).parents(".tab-wrapper__title").next().find("li").each(function (index) {
      if (!$this.is(':checked')) {
        $(this).find(".check-item").prop('checked', false);
        subItemsString += "0_";
      } else {
        $(this).find(".check-item").prop('checked', true);
        subItemsString += "1_";
      }
    });
    subItemsString = subItemsString.slice(0, -1);
    urlParams.set('step' + tab[1], subItemsString);
  }

  url.search = urlParams.toString();
  var new_url = url.toString(); // console.log(new_url);

  $(".gen-pdf").attr("href", new_url); // for 1.4 tab BEGIN

  if ($(this).hasClass('check-item--final-small')) {
    if (!$(this).is(':checked')) {
      $('.framework li[data-tab="' + tab[1] + '.' + tab[2] + '"]').hide();
    } else {
      $('.framework li[data-tab="' + tab[1] + '.' + tab[2] + '"]').show();
    }

    if ($(this).parents(".tab-wrapper__subitems").find(".check-item:checked").length == 0) {
      $('.framework li[data-tab="' + tab[1] + '"]').hide();
    }

    if ($(this).parents(".tab-wrapper__subitems").find(".check-item:checked").length > 0) {
      $('.framework li[data-tab="' + tab[1] + '"]').show();
    }
  } else if ($(this).hasClass('check-item--final')) {
    if (!$(this).is(':checked')) {
      $('.framework li[data-tab="' + tab[1] + '"]').hide();
      $('.framework li[data-tab="' + tab[1] + '"] li').hide();
    } else {
      $('.framework li[data-tab="' + tab[1] + '"]').show();
      $('.framework li[data-tab="' + tab[1] + '"] li').show();
    }
  } else {
    if (!$(this).is(':checked')) {
      $('.framework li[data-tab="' + tab[0] + '.' + tab[1] + '"]').hide();
    } else {
      $('.framework li[data-tab="' + tab[0] + '.' + tab[1] + '"]').show();
    }

    if ($(".check-item[id*='item_" + tab[0] + "_']:checked").length == 0) {
      $('.framework li[data-tab="' + tab[0] + '"]').hide();
    }

    if ($(".check-item[id*='item_" + tab[0] + "_']:checked").length > 0) {
      $('.framework li[data-tab="' + tab[0] + '"]').show();
    }
  } // for 1.4 tab END
  // store new pdf url in database


  post_id = $('#review_id').val();
  $.ajax({
    url: settings.ajaxurl,
    type: "POST",
    data: {
      action: 'update_pdf_url',
      post_id: post_id,
      new_url: new_url
    },
    success: function success(response) {}
  });
});
$(document).on('click', '.redirect-to-tab', function (e) {
  e.preventDefault();
  $(window).scrollTop(0);
  var tab = $(this).data('tab');
  tabMain = tab.toString().split('.').shift();
  $(".tab-wrapper").removeClass('active');
  $(".tab-wrapper[data-tab='" + tab + "']").addClass('active');
  $(".secondary-tabs a").removeClass('active');
  $(".secondary-tabs a[data-tab='" + tab + "']").addClass('active');
  $(".secondary-tabs").removeClass('active');
  $(".secondary-tabs[data-tab='" + tabMain + "']").addClass('active');
  $(".main-tabs a").removeClass('active');
  $(".main-tabs a[data-tab='" + tabMain + "']").addClass('active');
});
$(document).on('click', '.gen-pdf', function (e) {
  var id = $(this).data('id');
  $.ajax({
    url: settings.ajaxurl,
    type: "POST",
    data: {
      action: 'publish_review',
      id: id
    },
    success: function success(response) {}
  });
}); // remove uploaded images

$(document).on('click', '.remove-img', function (e) {
  var id = $(this).data('post_id');
  var name = $(this).data('name');
  $(this).parents(".tab-wrapper__item--file").removeClass("file-uploaded");
  $(this).parents(".uploaded").find(".name").text('');
  $(this).parents(".uploaded").find("img").attr("src", '');
  $.ajax({
    url: settings.ajaxurl,
    type: "POST",
    data: {
      action: 'remove_image',
      id: id,
      name: name
    },
    success: function success(response) {// $(".response").text(response);
    }
  });
}); // click on radio buttons bg image

$('input[name="pdf_bg_image_radio"], input[name="pdf_bg_roadmap_image_radio"]').on("change", function () {
  if ($(this).val() == 'pdf_bg_gradient') {
    $(this).parents(".tab-wrapper__item").next().addClass("hide");
    $(this).parents(".tab-wrapper__item").next().next().removeClass("hide");
  } else {
    $(this).parents(".tab-wrapper__item").next().removeClass("hide");
    $(this).parents(".tab-wrapper__item").next().next().addClass("hide");
  }
});
$(document).on('click', '.expand-extra-items', function (e) {
  $(this).parents(".tab-wrapper__items").toggleClass("show-extra-items"); // $(this).next().slideToggle();
});
$(document).on('click', '.remove-review', function (e) {
  $(".modal").show();
  id = $(this).data("id");
  $.ajax({
    url: settings.ajaxurl,
    type: "POST",
    data: {
      action: 'delete_review',
      id: id
    },
    success: function success(response) {
      location.reload();
    }
  });
});
$(document).on('click', '.close-modal, .modal__close', function (e) {
  $(".modal").hide();
});
$('.check-recom').on("change", function () {
  var tab_id = $(this).attr('id');
  tab_id = tab_id.replace('recom', '');
  post_id = $('#review_id').val();

  if ($(this).is(':checked')) {
    checked = 1;
  } else {
    checked = 0;
  }

  $.ajax({
    url: settings.ajaxurl,
    type: "POST",
    data: {
      action: 'update_recom',
      tab_id: tab_id,
      post_id: post_id,
      checked: checked
    },
    success: function success(response) {}
  });
});